/*
  RevoRope — carrusel COVERFLOW / arco de prueba social.

  El slide central tiene el foco; los laterales se inclinan en arco y se atenúan
  (coverflow). Este controlador NO calcula estilos: solo escribe la POSICIÓN
  numérica de cada slide en variables CSS (--rr-pos = desplazamiento con signo,
  --rr-depth = distancia al centro, --rr-z = orden) y marca el activo/ocultos.
  Toda la transformación (rotateY, escala, opacidad, translateZ) vive en home.css.

  Navegación: flechas prev/next, teclado (flechas + Inicio/Fin), clic en un
  lateral para centrarlo, y deslizar (puntero: ratón y táctil) o rueda horizontal
  de trackpad. Nunca secuestra el scroll vertical de la página (touch-action:pan-y
  en el escenario y solo actuamos cuando el gesto horizontal domina). El movimiento
  suave lo da la transición CSS, que prefers-reduced-motion colapsa a instantáneo.
*/
(function () {
  'use strict';

  var WINDOW = 2; // slides visibles a cada lado del central

  function pad2(num) {
    return num < 10 ? '0' + num : '' + num;
  }

  function initCarousel(root) {
    var stage = root.querySelector('.rr-social__stage');
    var track = root.querySelector('[data-rr-track]');
    if (!stage || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-rr-slide]'));
    var n = slides.length;
    if (!n) return;

    var prevBtn = root.querySelector('[data-rr-prev]');
    var nextBtn = root.querySelector('[data-rr-next]');
    var status = root.querySelector('[data-rr-status]');
    var idxEl = root.querySelector('[data-rr-index]');
    var totalEl = root.querySelector('[data-rr-total]');

    // Arranca centrado: los slides se abren en arco a ambos lados (coverflow
    // equilibrado) en vez de amontonarse a un lado.
    var active = Math.floor((n - 1) / 2);

    // Activa el modo coverflow (el CSS por defecto es una fila con scroll, por si
    // el JS no cargara). A partir de aquí las posiciones las pone este controlador.
    stage.classList.add('is-ready');
    if (totalEl) totalEl.textContent = pad2(n);

    function render() {
      for (var i = 0; i < n; i++) {
        var offset = i - active;
        var abs = Math.abs(offset);
        var clamped = Math.min(abs, WINDOW + 1); // acota la escala/translación de los ocultos
        var sign = offset < 0 ? -1 : (offset > 0 ? 1 : 0);
        var s = slides[i];

        s.style.setProperty('--rr-pos', sign * clamped);
        s.style.setProperty('--rr-depth', clamped);
        s.style.setProperty('--rr-z', 100 - clamped);

        if (abs > WINDOW) {
          s.setAttribute('data-rr-hidden', '');
        } else {
          s.removeAttribute('data-rr-hidden');
        }
        if (offset === 0) {
          s.setAttribute('data-rr-state', 'active');
        } else {
          s.removeAttribute('data-rr-state');
        }
      }

      if (prevBtn) prevBtn.setAttribute('aria-disabled', active <= 0 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', active >= n - 1 ? 'true' : 'false');
      if (idxEl) idxEl.textContent = pad2(active + 1);
      if (status) status.textContent = 'Foto ' + (active + 1) + ' de ' + n;
    }

    function go(i) {
      var next = Math.max(0, Math.min(n - 1, i));
      if (next === active) return;
      active = next;
      render();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });

    // Teclado sobre el track (enfocable: tabindex="0").
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); }
      else if (e.key === 'End') { e.preventDefault(); go(n - 1); }
    });

    // Clic en un lateral -> lo centra (se anula si venimos de arrastrar).
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (dragMoved) return;
        go(i);
      });
    });

    // --- Deslizar con el puntero (ratón + táctil), un paso por gesto. ---
    var SWIPE = 45;
    var pid = null, downX = 0, downY = 0, dragMoved = false, swiped = false;

    function onMove(e) {
      if (e.pointerId !== pid) return;
      var dx = e.clientX - downX, dy = e.clientY - downY;
      if (Math.abs(dx) > 6) dragMoved = true;
      if (!swiped && Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(active + (dx < 0 ? 1 : -1));
      }
    }
    function onUp(e) {
      if (e.pointerId !== pid) return;
      stage.classList.remove('is-grabbing');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      pid = null;
      // Deja que el evento click (posterior al pointerup) lea dragMoved antes de resetear.
      setTimeout(function () { dragMoved = false; }, 0);
    }
    // El arrastre y la rueda se escuchan en el ESCENARIO, no en la pista: la
    // pista es `pointer-events: none` desde el 26/08 (bug real, ver la nota en
    // home.css junto a `.rr-social__track`) para que los laterales del arco
    // vuelvan a ser pulsables. El escenario sí es alcanzable en toda su
    // superficie y cubre el mismo área.
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pid = e.pointerId; downX = e.clientX; downY = e.clientY;
      dragMoved = false; swiped = false;
      stage.classList.add('is-grabbing');
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    });

    // Rueda/trackpad horizontal. Solo cuando el eje X domina: nunca bloquea el
    // scroll vertical de la página.
    var wheelLock = false;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 12) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      go(active + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 380);
    }, { passive: false });

    render();
  }

  Array.prototype.slice.call(document.querySelectorAll('[data-rr-carousel]')).forEach(initCarousel);
})();
